import { cn } from '@Utils';

export interface ChainAvatarProps {
  size?: 'sm' | 'md';
  className?: string;
  /** Image URL for the avatar — when provided, takes precedence over initials. */
  image?: string;
  alt?: string;
  /** Used when `image` is not provided. */
  initials?: string;
  color?: string;
  textColor?: string;
}

const sizeClasses: Record<NonNullable<ChainAvatarProps['size']>, string> = {
  sm: 'h-9 w-9 text-xs',
  md: 'h-11 w-11 text-sm',
};

const ChainAvatar = ({
  size = 'md',
  className,
  image,
  alt,
  initials = '',
  color = '#E5E7EB',
  textColor = '#FFFFFF',
}: ChainAvatarProps) => {
  if (image) {
    return (
      <div
        className={cn(
          'flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-white',
          sizeClasses[size],
          className,
        )}>
        <img src={image} alt={alt ?? ''} className="h-full w-full object-contain p-1" />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-lg font-semibold tracking-tight',
        sizeClasses[size],
        className,
      )}
      style={{ backgroundColor: color, color: textColor }}>
      {initials}
    </div>
  );
};

export default ChainAvatar;
